import { render, staticRenderFns } from "./SecondGraduationSendDocument.vue?vue&type=template&id=c270f78a&scoped=true&"
import script from "./SecondGraduationSendDocument.vue?vue&type=script&lang=ts&"
export * from "./SecondGraduationSendDocument.vue?vue&type=script&lang=ts&"
import style0 from "./SecondGraduationSendDocument.vue?vue&type=style&index=0&id=c270f78a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c270f78a",
  null
  
)

export default component.exports